<!--  -->
<template>
  <div>
    <div style="margin-bottom:10px">
      <el-input v-model="pageIfonone.keyword" placeholder="请输入内容" style="width:200px" />
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" @click="reast">重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        label="标题"
        width="180"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="创建人"
        width="180"
        align="center"
      />
      <el-table-column
        prop="accountName"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooser(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { turntablelist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfonone: {
        page: 1,
        page_size: 10,
        keyword: null
      },
      tableData: [],
      total: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getprogramlist()
    },
    // 获取绑定列表
    async getprogramlist() {
      const data = await turntablelist(this.pageIfonone)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonone.pageSize = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageIfonone.page = e
      this.getprogramlist()
    },
    search() {
      this.pageIfonone.page = 1
      this.getprogramlist()
    },
    reast() {
      this.pageIfonone.page = 1
      this.pageIfonone.pageSize = 10
      this.pageIfonone.keyword = null
      this.getprogramlist()
    },
    chooser(row) {
      console.log('row', row)
      this.$emit('callbackr', row)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
